export default __webpack_public_path__ + "static/media/boulanger-logo.705a66f9.png";